export default __webpack_public_path__ + "static/media/testbg.082a1044.jpeg";